export const en = {
    'gender-and-age': 'gender: {gender}, age: {age}',
    'on-condition': 'on the condition "{condition}"'
};
